var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("Tipo")]),
          _vm._v(" "),
          _c("th", [_vm._v("Servidor IN")]),
          _vm._v(" "),
          _c("th", [_vm._v("Servidor OUT")]),
          _vm._v(" "),
          _c("th", [_vm._v("Usuario")]),
          _vm._v(" "),
          _c("th", [_vm._v("Contraseña")]),
          _vm._v(" "),
          _c("th", [_vm._v("Puerto")]),
          _vm._v(" "),
          _c("th", [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn-success",
                  attrs: { type: "button" },
                  on: { click: _vm.agregar }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.parametros, function(parametro, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _c("div", { staticClass: "form-field select" }, [
                  _c("div", { staticClass: "select-field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: parametro.type,
                            expression: "parametro.type"
                          }
                        ],
                        attrs: { name: "type[]", id: "type" + index },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              parametro,
                              "type",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v("Seleccione...")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "FTP" } }, [
                          _vm._v("FTP")
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "SFTP" } }, [
                          _vm._v("SFTP")
                        ])
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        "input-out": "",
                        placeholder: "Host o IP de servidor",
                        id: "server" + index,
                        name: "server[]"
                      },
                      model: {
                        value: parametro.server,
                        callback: function($$v) {
                          _vm.$set(parametro, "server", $$v)
                        },
                        expression: "parametro.server"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        "input-out": "",
                        placeholder: "Host o IP de servidor",
                        id: "server_out" + index,
                        name: "server_out[]"
                      },
                      model: {
                        value: parametro.server_out,
                        callback: function($$v) {
                          _vm.$set(parametro, "server_out", $$v)
                        },
                        expression: "parametro.server_out"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        "input-out": "",
                        placeholder: "Usuario",
                        id: "user_id" + index,
                        name: "user_id[]"
                      },
                      model: {
                        value: parametro.user_id,
                        callback: function($$v) {
                          _vm.$set(parametro, "user_id", $$v)
                        },
                        expression: "parametro.user_id"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      attrs: {
                        type: "password",
                        "input-out": "",
                        placeholder: "Contraseña",
                        id: "password_param" + index,
                        name: "password_param[]"
                      },
                      model: {
                        value: parametro.password,
                        callback: function($$v) {
                          _vm.$set(parametro, "password", $$v)
                        },
                        expression: "parametro.password"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  { staticClass: "form-field" },
                  [
                    _c("input-field", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "######",
                          expression: "'######'"
                        }
                      ],
                      attrs: {
                        "input-out": "",
                        placeholder: "Puerto",
                        id: "puerto" + index,
                        name: "port[]"
                      },
                      model: {
                        value: parametro.port,
                        callback: function($$v) {
                          _vm.$set(parametro, "port", $$v)
                        },
                        expression: "parametro.port"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "button",
                  {
                    staticClass: "btn-danger btn--text",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.eliminar(index)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                )
              ])
            ])
          }),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.parametros.length == 0,
                  expression: "parametros.length == 0"
                }
              ]
            },
            [_vm._m(0)]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "7" } }, [
      _c("strong", [_vm._v("No se ha agregado parámetros.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56465165", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56465165","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/clientes/TablaParametrosCliente.vue
// module id = 454
// module chunks = 0